import { SET_IS_DISABLING_MODULES } from '../actionTypes';
import { panelLayoutV2Actions } from '../reducer';

export default (isDisabling) =>
    panelLayoutV2Actions[SET_IS_DISABLING_MODULES](isDisabling);
